(function () {
  const ROOT_SELECTOR = '[data-challenge-weeks-list-root]';

  const initRoot = (root) => {
    if (!root || root.dataset.introInitialized === 'true') return;

    const intro = root.querySelector('[data-challenge-weeks-list-intro]');
    const content = root.querySelector('[data-challenge-weeks-list-content]');
    const trigger = root.querySelector('[data-challenge-weeks-list-enter]');

    if (!intro || !content || !trigger) return;

    root.dataset.introInitialized = 'true';

    trigger.addEventListener('click', () => {
      intro.hidden = true;
      content.hidden = false;

      if (window.ChallengeWeekMenuFitText) {
        window.ChallengeWeekMenuFitText.init(content);
      }
    });
  };

  const initAll = (container = document) => {
    container.querySelectorAll(ROOT_SELECTOR).forEach(initRoot);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(), { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initAll(event.target);
  });
})();
